import { AbstractApi } from '@/api/AbstractApi'
import { UserInterface } from '@/model/user/UserInterface'
import request from '@/api/request'

class SessionApi extends AbstractApi {
  async loginCheck(userToLogin: { username: string, password: string }): Promise<UserInterface> {
    try {
      const route = this.generateRoute({}, 'login-check')
      const { data } = await request.post(route, { user: userToLogin })

      return data.user
    } catch (e) {
      throw Error(e)
    }
  }

  async logout(): Promise<void> {
    const route = this.generateRoute({}, 'logout')

    await request.get(route)
  }
}

export default new SessionApi('session')
